import apiClient from '../client.js'

export const quotesAPI = {
  // Get user quotes
  async getQuotes(params = {}) {
    const response = await apiClient.get('/quotes', { params })
    return response.data
  },

  // Create new quote from cart
  async createQuote(data) {
    const response = await apiClient.post('/quotes', data)
    return response.data
  },

  // Get specific quote
  async getQuote(id) {
    const response = await apiClient.get(`/quotes/${id}`)
    return response.data
  },

  // Convert quote to order
  async convertToOrder(id, data) {
    const response = await apiClient.post(`/quotes/${id}/convert-to-order`, data)
    return response.data
  },

  // Admin: Get all quotes
  async getAdminQuotes(params = {}) {
    const response = await apiClient.get('/admin/quotes', { params })
    return response.data
  }
}
